export default __webpack_public_path__ + "static/media/fixture2_vs.4bcf8f21.png";